'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { SaveTripButton } from '~/components/TripOverview/hero/SaveTripButton';
import { ShareTripButton } from '~/components/TripOverview/hero/ShareTripButton';
import { useTripId } from '~/hooks/useTripId';
import styles from '../TripOverviewPage.module.css';
import { EmissionsBadge } from './EmissionsBadge';
type TripOverviewIntroProps = {
  title: string;
  dayCount: number;
  totalCarbonFootprint: number;
  journeyCarbonUsage?: {
    carEquivalent: number;
    flightEquivalent: number;
  };
};
const carbonFormatter = new Intl.NumberFormat('en-GB', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
export const TripOverviewIntro = t0 => {
  const $ = _c(23);
  const {
    title,
    dayCount,
    totalCarbonFootprint,
    journeyCarbonUsage
  } = t0;
  const t = useTranslations("journey");
  const tripId = useTripId();
  const showEmissionsSection = totalCarbonFootprint > 0;
  const hasUsageComparisons = typeof journeyCarbonUsage?.carEquivalent === "number" && typeof journeyCarbonUsage?.flightEquivalent === "number";
  const carbonSavings = hasUsageComparisons ? 100 / journeyCarbonUsage.flightEquivalent * totalCarbonFootprint - 100 : undefined;
  let formattedCarbonSavings;
  let t1;
  if ($[0] !== carbonSavings) {
    formattedCarbonSavings = typeof carbonSavings === "number" && Number.isFinite(carbonSavings) ? Math.round(carbonSavings) : undefined;
    t1 = typeof formattedCarbonSavings === "number" ? Math.abs(formattedCarbonSavings) : undefined;
    $[0] = carbonSavings;
    $[1] = formattedCarbonSavings;
    $[2] = t1;
  } else {
    formattedCarbonSavings = $[1];
    t1 = $[2];
  }
  const savingsPercentForBadge = t1;
  let t2;
  if ($[3] !== title) {
    t2 = <h1 className={styles.introTitle} id="overview-description-heading">{title}</h1>;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ShareTripButton className={styles.introActionButton} size="large" iconVariant="overviewIntro" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== tripId) {
    t4 = <div className={styles.introActions}>{t3}<SaveTripButton tripId={tripId} className={styles.introActionButton} size="large" iconVariant="overviewIntro" /></div>;
    $[6] = tripId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className={styles.introTitleRow}>{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== dayCount || $[12] !== formattedCarbonSavings || $[13] !== hasUsageComparisons || $[14] !== journeyCarbonUsage || $[15] !== savingsPercentForBadge || $[16] !== showEmissionsSection || $[17] !== t || $[18] !== totalCarbonFootprint) {
    t6 = showEmissionsSection ? <div className={styles.emissionsRow}><strong className={styles.emissionsDays}>{t("days_count", {
          count: dayCount
        })}</strong><div className={styles.emissionsBox}><p className={styles.emissionsSummary}>{carbonFormatter.format(totalCarbonFootprint)} kg CO<sub>2</sub></p>{typeof savingsPercentForBadge === "number" ? <EmissionsBadge savingsPercentForBadge={savingsPercentForBadge} totalCarbonFootprint={totalCarbonFootprint} formattedCarbonSavings={formattedCarbonSavings} hasUsageComparisons={hasUsageComparisons} journeyCarbonUsage={journeyCarbonUsage} /> : null}</div></div> : null;
    $[11] = dayCount;
    $[12] = formattedCarbonSavings;
    $[13] = hasUsageComparisons;
    $[14] = journeyCarbonUsage;
    $[15] = savingsPercentForBadge;
    $[16] = showEmissionsSection;
    $[17] = t;
    $[18] = totalCarbonFootprint;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t5 || $[21] !== t6) {
    t7 = <section id="overview-description" className={styles.introBlock} aria-labelledby="overview-description-heading">{t5}{t6}</section>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};